import _AbsenceSvg from '@src/assets/absence.svg?react';
import _AccountBoxSvg from '@src/assets/account-box.svg?react';
import _AddItemSvg from '@src/assets/add-item.svg?react';
import _AdminSvg from '@src/assets/admin.svg?react';
import _ArrowDownSvg from '@src/assets/arrow-down.svg?react';
import _ArrowDropDownSvg from '@src/assets/arrow-drop-down.svg?react';
import _ArrowDropUpSvg from '@src/assets/arrow-drop-up.svg?react';
import _ArrowLeftSvg from '@src/assets/arrow-left.svg?react';
import _ArrowRightSvg from '@src/assets/arrow-right.svg?react';
import _ArrowUpSvg from '@src/assets/arrow-up.svg?react';
import _BookSvg from '@src/assets/book.svg?react';
import _CakeSvg from '@src/assets/cake.svg?react';
import _CalendarSvg from '@src/assets/calendar.svg?react';
import _CalendarTodaySvg from '@src/assets/calendar_today.svg?react';
import _CallSvg from '@src/assets/call.svg?react';
import _CheckSvg from '@src/assets/check.svg?react';
import _CheckboxSvg from '@src/assets/checkbox.svg?react';
import _CheckboxCheckedSvg from '@src/assets/checkbox-checked.svg?react';
import _CircleCheckSvg from '@src/assets/circle-check.svg?react';
import _CircleCloseSvg from '@src/assets/circle-close.svg?react';
import _ClockSvg from '@src/assets/clock.svg?react';
import _CloseSvg from '@src/assets/close.svg?react';
import _CompareSvg from '@src/assets/compare.svg?react';
import _ContentCopySvg from '@src/assets/content-copy.svg?react';
import _ContratSvg from '@src/assets/contract.svg?react';
import _CopySvg from '@src/assets/copy.svg?react';
import _CrewSvg from '@src/assets/crew.svg?react';
import _DashboardSvg from '@src/assets/dashboard.svg?react';
import _DeleteSvg from '@src/assets/delete.svg?react';
import _DetailsSvg from '@src/assets/details.svg?react';
import _DoubleArrowLeftSvg from '@src/assets/double-arrow-left.svg?react';
import _DoubleArrowRightSvg from '@src/assets/double-arrow-right.svg?react';
import _DownloadSvg from '@src/assets/download.svg?react';
import _DragSvg from '@src/assets/drag.svg?react';
import _EyeSvg from '@src/assets/eye-on.svg?react';
import _EyeOffSvg from '@src/assets/eye-off.svg?react';
import _FamilySvg from '@src/assets/family.svg?react';
import _FileSvg from '@src/assets/file.svg?react';
import _FilterSvg from '@src/assets/filter.svg?react';
import _FilterFilledSvg from '@src/assets/filter-filled.svg?react';
import _FilterXSvg from '@src/assets/filter-x.svg?react';
import _FilterXActiveSvg from '@src/assets/filter-x-active.svg?react';
import _FlagSvg from '@src/assets/flag.svg?react';
import _FlagXSvg from '@src/assets/flag-x.svg?react';
import _FullScreenSvg from '@src/assets/full-screen.svg?react';
import _FullScreenExitSvg from '@src/assets/full-screen-exit.svg?react';
import _HomeSvg from '@src/assets/home.svg?react';
import _InfoSvg from '@src/assets/info.svg?react';
import _KeyboardBackspaceSvg from '@src/assets/keyboard-backspace.svg?react';
import _LogoSvg from '@src/assets/logo.svg?react';
import _MailSvg from '@src/assets/mail.svg?react';
import _MailSentSvg from '@src/assets/mailsent.svg?react';
import _MobileSvg from '@src/assets/mob.svg?react';
import _NotificationsSvg from '@src/assets/notifications.svg?react';
import _OfficeSvg from '@src/assets/office.svg?react';
import _PartySvg from '@src/assets/party.svg?react';
import _PencilSvg from '@src/assets/pencil.svg?react';
import _PhoneSvg from '@src/assets/phone.svg?react';
import _PhoneBookSvg from '@src/assets/phonebook.svg?react';
import _PillSvg from '@src/assets/pill.svg?react';
import _PlusSvg from '@src/assets/plus.svg?react';
import _RadioSvg from '@src/assets/radio.svg?react';
import _RadioCheckedSvg from '@src/assets/radio-checked.svg?react';
import _ReportingSvg from '@src/assets/reporting.svg?react';
import _RefreshSvg from '@src/assets/refresh.svg?react';
import _ResetPasswordSvg from '@src/assets/reset-password.svg?react';
import _SearchSvg from '@src/assets/search.svg?react';
import _SettingSvg from '@src/assets/setting.svg?react';
import _ShippingSvg from '@src/assets/shipping.svg?react';
import _SquareInfoSvg from '@src/assets/square-info.svg?react';
import _StarSvg from '@src/assets/star.svg?react';
import _StarFilledSvg from '@src/assets/star_filled.svg?react';
import _SupportSvg from '@src/assets/support.svg?react';
import _TasksSvg from '@src/assets/tasks.svg?react';
import _UmbrellaSvg from '@src/assets/umbrella.svg?react';
import _UploadSvg from '@src/assets/upload.svg?react';
import _UserSvg from '@src/assets/user.svg?react';
import _VerticalDoubleCheckSvg from '@src/assets/vertical-double-check.svg?react';
import _WarningSvg from '@src/assets/warning.svg?react';
import _WestSvg from '@src/assets/west.svg?react';

import csi from './createSvgIcon';

export { default as DoubleCheckIcon } from './DoubleCheckIcon';

export const Logo = csi('Logo', _LogoSvg, {
  viewBox: '0 0 150 71',
});
export const AddItemIcon = csi('', _AddItemSvg, { viewBox: '0 0 24 24' });
export const AccountBoxIcon = csi('', _AccountBoxSvg, { viewBox: '0 0 24 24' });
export const AdminIcon = csi('', _AdminSvg, { viewBox: '0 0 24 24' });
export const ClockIcon = csi('', _ClockSvg, { viewBox: '0 0 24 24' });
export const CloseIcon = csi('', _CloseSvg, { viewBox: '0 0 20 20' });
export const DeleteIcon = csi('', _DeleteSvg, { viewBox: '0 0 24 24' });
export const EyeIcon = csi('', _EyeSvg);
export const EyeOffIcon = csi('', _EyeOffSvg);
export const ReportingIcon = csi('', _ReportingSvg, {});
export const RefreshIcon = csi('', _RefreshSvg, { viewBox: '0 0 22 16' });
export const ResetPasswordIcon = csi('', _ResetPasswordSvg, {
  viewBox: '0 0 24 24',
});
export const UserIcon = csi('', _UserSvg, {});
export const DownloadIcon = csi('', _DownloadSvg, {});
export const UploadIcon = csi('', _UploadSvg, { viewBox: '0 0 24 24' });
export const PlusIcon = csi('', _PlusSvg, { viewBox: '0 0 24 24' });
export const BookIcon = csi('', _BookSvg, { viewBox: '0 0 22 16' });
export const InfoIcon = csi('', _InfoSvg, { viewBox: '0 0 24 24' });
export const SearchIcon = csi('', _SearchSvg, { viewBox: '0 0 24 24' });
export const StarIcon = csi('', _StarSvg, { viewBox: '0 0 24 24' });
export const StarFilledIcon = csi('', _StarFilledSvg, { viewBox: '0 0 24 24' });
export const ArrowUpIcon = csi('', _ArrowUpSvg, { viewBox: '0 0 18 18' });
export const ArrowDownIcon = csi('', _ArrowDownSvg, { viewBox: '0 0 18 18' });
export const ArrowDropUpIcon = csi('', _ArrowDropUpSvg, {
  viewBox: '0 0 12 12',
});
export const ArrowDropDownIcon = csi('', _ArrowDropDownSvg, {
  viewBox: '0 0 12 12',
});
export const WarningIcon = csi('', _WarningSvg, { viewBox: '0 0 20 20' });
export const UmbrellaIcon = csi('', _UmbrellaSvg, { viewBox: '0 0 24 24' });
export const PhoneIcon = csi('', _PhoneSvg, { viewBox: '0 0 24 24' });
export const PhoneBookIcon = csi('', _PhoneBookSvg, { viewBox: '0 0 24 24' });
export const PillIcon = csi('', _PillSvg, { viewBox: '0 0 24 24' });
export const FileIcon = csi('', _FileSvg, { viewBox: '0 0 24 24' });
export const FilterIcon = csi('', _FilterSvg, { viewBox: '0 0 24 24' });
export const FilterFilledIcon = csi('', _FilterFilledSvg, {
  viewBox: '0 0 24 24',
});
export const FilterXIcon = csi('', _FilterXSvg, { viewBox: '0 0 24 24' });
export const FilterXActiveIcon = csi('', _FilterXActiveSvg, {
  viewBox: '0 0 24 24',
});
export const FlagIcon = csi('', _FlagSvg, { viewBox: '0 0 24 24' });
export const FlagXIcon = csi('', _FlagXSvg, { viewBox: '0 0 24 24' });
export const HomeIcon = csi('', _HomeSvg, { viewBox: '0 0 24 24' });
export const FamilyIcon = csi('', _FamilySvg, { viewBox: '0 0 24 24' });
export const CalendarIcon = csi('', _CalendarSvg, { viewBox: '0 0 24 24' });
export const CalendarTodayIcon = csi('', _CalendarTodaySvg, {
  viewBox: '0 0 24 24',
});
export const ArrowRightIcon = csi('', _ArrowRightSvg, { viewBox: '0 0 18 18' });
export const ArrowLeftIcon = csi('', _ArrowLeftSvg, { viewBox: '0 0 18 18' });
export const DoubleArrowRightIcon = csi('', _DoubleArrowRightSvg, {
  viewBox: '0 0 18 18',
});
export const DoubleArrowLeftIcon = csi('', _DoubleArrowLeftSvg, {
  viewBox: '0 0 18 18',
});
export const CompareIcon = csi('', _CompareSvg, { viewBox: '0 0 24 24' });
export const ContentCopyIcon = csi('', _ContentCopySvg, {
  viewBox: '0 0 24 24',
});
export const CopyIcon = csi('', _CopySvg, { viewBox: '0 0 24 24' });
export const ContractIcon = csi('', _ContratSvg, { viewBox: '0 0 24 24' });
export const CrewIcon = csi('', _CrewSvg, { viewBox: '0 0 24 24' });
export const AbsenceIcon = csi('', _AbsenceSvg, { viewBox: '0 0 24 24' });
export const CallIcon = csi('', _CallSvg, { viewBox: '0 0 24 24' });
export const ShippingIcon = csi('', _ShippingSvg, { viewBox: '0 0 24 24' });
export const CheckIcon = csi('', _CheckSvg, { viewBox: '0 0 24 24' });
export const CheckboxIcon = csi('', _CheckboxSvg, { viewBox: '0 0 18 18' });
export const CheckboxCheckedIcon = csi('', _CheckboxCheckedSvg, {
  viewBox: '0 0 18 18',
});
export const CircleCheckIcon = csi('', _CircleCheckSvg, {
  viewBox: '0 0 24 24',
});
export const CircleCloseIcon = csi('', _CircleCloseSvg, {
  viewBox: '0 0 24 24',
});
export const SquareInfoIcon = csi('', _SquareInfoSvg, { viewBox: '0 0 24 24' });
export const PencilIcon = csi('', _PencilSvg, { viewBox: '0 0 24 24' });
export const SupportIcon = csi('', _SupportSvg, { viewBox: '0 0 24 24' });
export const TasksIcon = csi('', _TasksSvg, { viewBox: '0 0 24 24' });
export const MailIcon = csi('', _MailSvg, { viewBox: '0 0 24 24' });
export const MailSentIcon = csi('', _MailSentSvg, { viewBox: '0 0 24 24' });
export const NotificationsIcon = csi('', _NotificationsSvg, {
  viewBox: '0 0 24 24',
});
export const MobileIcon = csi('', _MobileSvg, { viewBox: '0 0 24 24' });
export const KeyboardBackspaceIcon = csi('', _KeyboardBackspaceSvg, {
  viewBox: '0 0 24 24',
});
export const WestIcon = csi('', _WestSvg, { viewBox: '0 0 24 24' });
export const OfficeIcon = csi('', _OfficeSvg, { viewBox: '0 0 24 24' });
export const CakeIcon = csi('', _CakeSvg, { viewBox: '0 0 24 24' });
export const PartyIcon = csi('', _PartySvg, { viewBox: '0 0 24 24' });
export const RadioIcon = csi('', _RadioSvg, { viewBox: '0 0 18 18' });
export const RadioCheckedIcon = csi('', _RadioCheckedSvg, {
  viewBox: '0 0 18 18',
});
export const SettingIcon = csi('', _SettingSvg, { viewBox: '0 0 24 24' });
export const DragIcon = csi('', _DragSvg, { viewBox: '0 0 24 24' });
export const FullScreenIcon = csi('', _FullScreenSvg, { viewBox: '0 0 24 24' });
export const FullScreenExitIcon = csi('', _FullScreenExitSvg, {
  viewBox: '0 0 24 24',
});
export const DashboardIcon = csi('', _DashboardSvg, { viewBox: '0 0 24 24' });
export const VerticalDoubleCheckIcon = csi('', _VerticalDoubleCheckSvg, { viewBox: '0 0 24 24' });
export const DetailsIcon = csi('', _DetailsSvg, { viewBox: '0 0 24 24' });
